(function () {
  function closeDetails(except) {
    document.querySelectorAll("[data-shopify-filters] details[open]").forEach(function (item) {
      if (item !== except) item.removeAttribute("open");
    });
  }

  function closeDrawer() {
    var drawer = document.getElementById("CollectionFilterDrawer");
    if (!drawer) return;
    drawer.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  document.addEventListener("toggle", function (event) {
    var item = event.target;
    if (!item || item.tagName !== "DETAILS" || !item.open) return;
    if (!item.closest("[data-shopify-filters]")) return;
    closeDetails(item);
  }, true);

  document.addEventListener("click", function (event) {
    if (event.target.closest("[data-filter-drawer-open]")) {
      var drawer = document.getElementById("CollectionFilterDrawer");
      if (!drawer) return;
      drawer.classList.add("is-open");
      document.body.style.overflow = "hidden";
      var focusable = drawer.querySelector("summary, a, button");
      if (focusable) focusable.focus();
      return;
    }
    if (event.target.closest("[data-filter-drawer-close]")) {
      event.preventDefault();
      closeDrawer();
      return;
    }
    if (!event.target.closest("[data-shopify-filters] details")) closeDetails(null);
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    closeDetails(null);
    closeDrawer();
  });
})();
